import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import PlanVisit from "@/pages/PlanVisit";
import About from "@/pages/About";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/packages/:id" element={<PackageDetail />} />
            <Route path="/plan-your-visit" element={<PlanVisit />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid rgba(212, 175, 55, 0.35)",
              color: "#F5F5F0",
              fontFamily: "Outfit, sans-serif",
              borderRadius: "0",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
